"use strict";

exports.__esModule = true;
exports.default = void 0;
var fontUrl = 'https://res.cloudinary.com/dgg9enyjv/raw/upload/v1525075261/keittiomaailma/fonts/';
var keittiomaailmaFonts = "\n@font-face {\n  font-family: 'Apercu';\n  src: url(" + fontUrl + "apercu-regular.woff) format(\"woff\"),\n       url(" + fontUrl + "apercu_regular_pro.otf) format(\"opentype\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: 'Apercu';\n  src: url(" + fontUrl + "apercu_bold_pro.otf) format(\"opentype\");\n  font-weight: 700;\n}\n";
var _default = exports.default = keittiomaailmaFonts;